export const NAVBAR_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    background_color: "#ffffff",
    hamburger_icon: "",
    hamburger_icon_alt: "",
    logo_icon: "",
    logo_icon_alt: "",
    mobile_cancel_icon: "",
    mobile_cancel_icon_alt: "",
    program_name: "",
    program_name_text_color: "#000000",
    horizontal_stripe_color: "#BE2330",
    status: true,
  },

  NAVBAR_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "show_hamburger",
      label: "Show Hamburger Menu on Mobile",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show the hamburger icon on the mobile bar (hides the drawer when off)",
      defaultValue: true,
    },
    {
      fieldName: "hamburger_icon",
      label: "Hamburger Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload hamburger menu icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "hamburger_icon_alt",
      label: "Hamburger Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for hamburger icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "logo_icon",
      label: "Logo Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "logo_icon_alt",
      label: "Logo Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for logo icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_cancel_icon",
      label: "Mobile Cancel Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile cancel icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_cancel_icon_alt",
      label: "Mobile Cancel Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for mobile cancel icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "program_name",
      label: "Program Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter program name (e.g., MBA)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "program_name_text_color",
      label: "Program Name Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter program name text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "horizontal_stripe_color",
      label: "Horizontal Stripe Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter horizontal stripe color",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable navbar",
      defaultValue: true,
    },
  ],
};

export const MENU_ITEM_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    parent_id: null,
    title: "",
    slug: "",
    url: "",
    status: true,
    priority: 1,
    text_color: "#000000",
    is_button: false,
    button_color: "#BE2330",
  },

  MENU_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter menu title (e.g., MBA)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "parent_id",
      label: "Parent Menu",
      value: null,
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select parent menu",
      required: false,
      defaultValue: null,
      options: [],
    },
    {
      fieldName: "slug",
      label: "Slug",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Auto-generated from title",
      defaultValue: "",
    },
    {
      fieldName: "url",
      label: "URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/programmes/mba (optional)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "priority",
      label: "Priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display priority",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable menu item",
      defaultValue: true,
    },
    {
      fieldName: "text_color",
      label: "Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "is_button",
      label: "Is Button",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Display as button",
      defaultValue: false,
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
  ],

  TREE_CONFIG: {
    treeTitle: "Menu Structure",
    treeIcon: "🌳",
    emptyMessage: "No menu items yet. Add your first one below.",

    itemDisplayFields: {
      primary: "title",
      secondary: "slug",
      statusField: "status",
      statusInactiveLabel: "Inactive",
      childrenField: "children",
    },

    fieldMappings: {
      id: "id",
      parentId: "parent_id",
      orderIndex: "priority",
      title: "title",
      slug: "slug",
      url: "url",
      isActive: "status",
    },

    parentFieldName: "parent_id",
    parentTopLevelValue: "null",
    parentTopLevelLabel: "-- Top Level --",

    formLabels: {
      addNew: "➕ Add New Menu Item",
      edit: "✏️ Edit Menu Item",
      saveButton: "Add Menu Item",
      updateButton: "Update Menu Item",
      newButton: "New",
      cancelButton: "Cancel",
    },

    deleteConfirmation: (item: any) =>
      `Delete "${item.title}"? This will also delete all child items.`,

    requiresParentComponent: true,
    parentComponentName: "Navbar",
    parentIdFieldName: "navbar_id",
    childItemsFieldName: "menuItems",
    parentComponentTitle: "Navbar Settings",
    parentComponentSaveButtonText: "Save Navbar Settings",
    parentComponentCreateSuccessMessage: "Navbar created successfully",
    parentComponentUpdateSuccessMessage: "Navbar settings saved successfully",
    requireParentMessage:
      "Please save the Navbar Settings first before creating menu items. The navbar must be created before you can add menu items.",
    parentComponentMessage: {
      title: "Navbar Not Created Yet",
      description:
        "Please save the Navbar Settings above before adding menu items.",
    },
  },
};
